import $ from 'jquery'

Ready(function() {
  $('body').on('change', 'form[data-autosubmit=true]', function(e) {
    $(this).closest('form').submit();
  });
});
